import { globalBreak } from "@/styles/break";
import { resBreak } from "@/utils/resBreak";
import { SxProps, Theme } from "@mui/material";

export const NavbarDialogSX:SxProps = {
    "& .MuiDialog-container": {
        justifyContent: "flex-start",
        alignItems: "stretch",
    }
}				

export const NavbarDialogPaperPropsSX = (activeMenu:number):SxProps => ({
    height: "100vh",
    width: 'auto',
    overflow:'hidden',
    '& > div':{
        overflowY:'auto',
        maxHeight:globalBreak({mobile:'90vh', desktop:'100vh'}),
    },
    '& .menu-navigation-elem':{
        overflowY:'auto',
        p:2,
        maxHeight:globalBreak({mobile:'90vh', desktop:'100vh'}),
        '::-webkit-scrollbar': {
            width: 4
        },
        '::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            marginTop: 0.5,
            marginBottom: 0.5
        },
        '::-webkit-scrollbar-thumb': {
            background: '#888'
        },
        '::-webkit-scrollbar-thumb:hover': {
            background: '#555'
        }
    }
})

export const NavbarMenuListSX = (activeMenu:number):SxProps => ({
    width: resBreak<'width'>({mobile:270, tablet:270, desktop:270, desktopL:270, desktopXL:375}),
    mt:3,
    borderRight: activeMenu !==-1 ?'1px solid' : 'none',
    pr:2.5,
    py:0,
    "& #all_categories_menu_back_menuitem, #all_categories_label_menuitem":{
        '&.Mui-focusVisible,.Mui-focused,:hover':{
            bgcolor:'transparent'
        }
    },
    "& #all_categories_menu_back_menuitem #all_categories_menu_back_button:hover":{
        textDecoration:'underline'
    },
    "& #all_categories_menu_back_menuitem":{ 
        height: '3em', 
        px: 2 
    }
});

export const NavbarMenuItemSX:SxProps = {
    display:'flex',
    justifyContent:'space-between',
    whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
    borderRadius:1,
    my:0.5,
    p:0,
    '& .selected':{
        bgcolor:'navbar.primary'
    },
    "&.Mui-focusVisible,.Mui-focused,:hover": {
        bgcolor: "navbar.primary",
        outline:'none'
    },
    '& > *':{
        cursor:'pointer'
    },
    '& svg':{
        fontSize:12,
        transition: 'all 200ms'
    },
    '& > button':{
        justifyContent:'space-between',
        px:2,
        py:0.75,
        columnGap:2,
        '& *':{
            pointerEvents:'none'
        }
    },
    '& > button[aria-expanded="true"] svg':{
        transform:'rotate(90deg)'
    }
}

export const NavbarSubMenuContainerSX:SxProps<Theme> = (theme: Theme) => ({
    position: 'fixed',
    left: resBreak<'left'>({mobile:0, tablet:300, desktop:300, desktopL:300, desktopXL:400}),
    height: resBreak<'height'>({mobile:"90vh", desktop:"100vh", tablet:"90vh"}),
    top: 0,
    bottom: 0,
    bgcolor: '#fff',
    width: globalBreak({mobile:300, desktop:325, desktopXL:400}),
    py:2.5,
    pt:globalBreak({mobile:1, desktop:2}),
    pl:globalBreak({mobile:2, desktop:0}),
    zIndex:globalBreak({mobile:theme.zIndex.modal+1, desktop:'unset'}),

    '& .content-recomnedation-widget':{
        '& .category-text-spot-header':{
            display:'block',
            fontWeight:'bold',
            mt:2.5,
            mb:0.5,
            py:0.75,
            px:2
            
        },
        '& a':{
            p:1,
            px:2,
            my:0.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#000',
            whiteSpace:'break-spaces',
            borderRadius: 1,
            columnGap:2,

            '& p':{
                fontSize:16
            },
            '& svg':{
                height: 12,
                mt: '3px'
            }
        },
        '& a:focus-visible,a:hover':{
            bgcolor:'navbar.primary',
            outline:'none'
        }
    }
})


export const NavbarSubMenuSX:SxProps = {
    mt: globalBreak({mobile:'unset', desktop:'4.2em'}), 
    pt: 0.5,
    pr:3,
    maxHeight: globalBreak({mobile:'100vh', desktop:'calc(100vh - 5em)'}),
    overflowY:'auto',
    '& a:hover':{
        textDecoration:'none'
    },
    '::-webkit-scrollbar': {
		width: 4
	},
	'::-webkit-scrollbar-track': {
		background: '#f1f1f1',
		marginTop: 0.5,
		marginBottom: 0.5
	},
	'::-webkit-scrollbar-thumb': {
		background: '#888'
	},
	'::-webkit-scrollbar-thumb:hover': {
		background: '#555'
	}
}

export const NavbarSubMenuItemSX:SxProps = {
    p:0,
    "&.Mui-focusVisible,.Mui-focused,:hover": {
        bgcolor: "transparent",
        outline:'none'
    },
    '& a':{
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        py:0.75,
        px:2,
        my:0.5,
        width:'100%',
        borderRadius:1,
        '& *':{
            pointerEvents:'none'
        }
    },
    '& a.Mui-focusVisible,a.Mui-focused,a:hover':{
        bgcolor: "navbar.primary",
        borderRadius:1,
        outline:'none'
    }
}